import React from 'react';
import EmptyStateCard from '@/views/components/misc/EmptyStateCard';

type Props = {
  hasAccounts: boolean;
};

enum EmptyStateType {
  NO_ACCOUNTS = 'NO_ACCOUNTS',
}

const ImportAccountsEmptyPage: React.FC<Props> = ({ hasAccounts }: Props) => {
  const i18nEmptyStatePath = 'EmptyStateCard.Planning.ImportAccounts';

  const emptyStateDefinition = {
    [EmptyStateType.NO_ACCOUNTS]: {
      titlePath: `${i18nEmptyStatePath}.NoAccount.Title`,
      messagePath: `${i18nEmptyStatePath}.NoAccount.Message`,
    },
  };

  return <>{!hasAccounts ? <EmptyStateCard {...emptyStateDefinition[EmptyStateType.NO_ACCOUNTS]} /> : null}</>;
};

export default ImportAccountsEmptyPage;
